// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function log(...args: any[]) {
  console.log(...args)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function debug(...args: any[]) {
  if (import.meta.env.DEV) console.debug(...args)
}
